import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import {
	CompanyLandListResult,
	CompanyLandsState,
} from '@localTypes/companyLands';

const initialState: CompanyLandsState = {};

export const companyLandsSlice = createSlice({
	initialState,
	name: 'company_lands',
	reducers: {
		clearAllCompanyLands: () => ({}),
		clearCompanyLands: (state, action: PayloadAction<number>) => {
			const companyId = action.payload;
			delete state[companyId];
		},
		setCompanyLands: (state, action: PayloadAction<{
			companyId: number;
			result: CompanyLandListResult['result'];
			total: number;
		}>) => {
			const {
				companyId,
				result,
				total,
			} = action.payload;
			state[companyId] = {
				isError: false,
				isLoading: false,
				result,
				total,
			};
		},
		setCompanyLandsError: (state, action: PayloadAction<{
			companyId: number;
			isError: boolean;
		}>) => {
			const {
				companyId,
				isError,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
					total: 0,
				};
			}
			state[companyId].isError = isError;
		},
		setCompanyLandsLoading: (state, action: PayloadAction<{
			companyId: number;
			isLoading: boolean;
		}>) => {
			const {
				companyId,
				isLoading,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
					total: 0,
				};
			}
			state[companyId].isLoading = isLoading;
		},
	},
});

export const {
	clearAllCompanyLands,
	clearCompanyLands,
	setCompanyLands,
	setCompanyLandsError,
	setCompanyLandsLoading,
} = companyLandsSlice.actions;

export const companyLandsReducer = companyLandsSlice.reducer;
